<template>
    <div>
        <link href="/themes/web/assets/css/unit-detail.css" rel="stylesheet">
        <link href="/themes/web/assets/css/exchange-gift.css" rel="stylesheet">
              
        <div class="container">
            <div id="page-header-fixed">
                <div class="">
                    <div id="page-header">
                        <ul class="breadcrumb">
                            <li class="icon"><img src="/themes/web/assets/images/back-to.svg" alt=""></li>
                            <li class="active"> {{$t('exchange_gift')}}</li>
                        </ul>
                        <div class="buttons">
                            <div class="">
                                <router-link :to="{ name: 'buy_sticker' }">
                                    <button class="btn btn-buy-sticker">
                                        <i class="ito-icon-buy-sticker"></i>
                                        {{$t('buy_sticker')}}
                                    </button>
                                </router-link>
                                <router-link :to="{ name: 'exchange_history' }">
                                    <button class="btn btn-exchanger-history">
                                        <i class="ito-icon-exchanger-history"></i>
                                        {{$t('exchange_history')}}
                                    </button>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <h6>Exchange today: 1/3</h6>
            <div class="exchange-gift-content">
                <div class="row">
                    <div class="col-md-3">
                        <div class="gift-item">
                            <div class="gift-item-img">
                                <img src="/themes/web/assets/images/gift.png">
                            </div>
                            <div class="gift-detail">
                                <div class="gift-title">Gift exchange name Gift exchange name</div>
                                <div class="gift-button" type="button" onclick="$('#popGift1').modal('show');" data-toggle="modal" data-target="#loginModal">Exchange
                                </div>
                                <div class="gift-progress">
                                    <div class="progress-text">Remaining: <b>272/300</b></div>
                                    <div class="progress-bar">
                                        <div class="progress-active" style="width: 70%"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="gift-item">
                            <div class="gift-item-img">
                                <img src="/themes/web/assets/images/gift2.png">
                            </div>
                            <div class="gift-detail">
                                <div class="gift-title">Gift exchange name Gift exchange name</div>
                                <div class="gift-button">Exchange</div>
                                <div class="gift-progress">
                                    <div class="progress-text">Remaining: <b>272/300</b></div>
                                    <div class="progress-bar">
                                        <div class="progress-active" style="width: 70%"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="gift-item">
                            <div class="gift-item-img">
                                <img src="/themes/web/assets/images/gift.png">
                            </div>
                            <div class="gift-detail">
                                <div class="gift-title">Gift exchange name Gift exchange name</div>
                                <div class="gift-button">Exchange</div>
                                <div class="gift-progress">
                                    <div class="progress-text">Remaining: <b>272/300</b></div>
                                    <div class="progress-bar">
                                        <div class="progress-active" style="width: 70%"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="gift-item">
                            <div class="gift-item-img">
                                <img src="/themes/web/assets/images/gift2.png">
                            </div>
                            <div class="gift-detail">
                                <div class="gift-title">Gift exchange name Gift exchange name</div>
                                <div class="gift-button">Exchange</div>
                                <div class="gift-progress">
                                    <div class="progress-text">Remaining: <b>272/300</b></div>
                                    <div class="progress-bar">
                                        <div class="progress-active" style="width: 70%"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="gift-item">
                            <div class="gift-item-img">
                                <img src="/themes/web/assets/images/gift.png">
                            </div>
                            <div class="gift-detail">
                                <div class="gift-title">Gift exchange name Gift exchange name</div>
                                <div class="gift-button">Exchange</div>
                                <div class="gift-progress">
                                    <div class="progress-text">Remaining: <b>272/300</b></div>
                                    <div class="progress-bar">
                                        <div class="progress-active" style="width: 70%"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="gift-item">
                            <div class="gift-item-img">
                                <img src="/themes/web/assets/images/gift2.png">
                            </div>
                            <div class="gift-detail">
                                <div class="gift-title">Gift exchange name Gift exchange name</div>
                                <div class="gift-button">Exchange</div>
                                <div class="gift-progress">
                                    <div class="progress-text">Remaining: <b>272/300</b></div>
                                    <div class="progress-bar">
                                        <div class="progress-active" style="width: 70%"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="exchange-gift-item">
                            <div class="gift-item">
                                <div class="gift-item-img">
                                    <img src="/themes/web/assets/images/gift.png">
                                </div>
                                <div class="gift-detail">
                                    <div class="gift-title">Gift exchange name Gift exchange name</div>
                                    <div class="gift-button">Exchange</div>
                                    <div class="gift-progress">
                                        <div class="progress-text">Remaining: <b>272/300</b></div>
                                        <div class="progress-bar">
                                            <div class="progress-active" style="width: 70%"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="gift-item">
                            <div class="gift-item-img">
                                <img src="/themes/web/assets/images/gift2.png">
                            </div>
                            <div class="gift-detail">
                                <div class="gift-title">Gift exchange name Gift exchange name</div>
                                <div class="gift-button">Exchange</div>
                                <div class="gift-progress">
                                    <div class="progress-text">Remaining: <b>272/300</b></div>
                                    <div class="progress-bar">
                                        <div class="progress-active" style="width: 70%"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="gift-item">
                            <div class="gift-item-img">
                                <img src="/themes/web/assets/images/gift.png">
                            </div>
                            <div class="gift-detail">
                                <div class="gift-title">Gift exchange name Gift exchange name</div>
                                <div class="gift-button">Exchange</div>
                                <div class="gift-progress">
                                    <div class="progress-text">Remaining: <b>272/300</b></div>
                                    <div class="progress-bar">
                                        <div class="progress-active" style="width: 70%"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="gift-item">
                            <div class="gift-item-img">
                                <img src="/themes/web/assets/images/gift2.png">
                            </div>
                            <div class="gift-detail">
                                <div class="gift-title">Gift exchange name Gift exchange name</div>
                                <div class="gift-button">Exchange</div>
                                <div class="gift-progress">
                                    <div class="progress-text">Remaining: <b>272/300</b></div>
                                    <div class="progress-bar">
                                        <div class="progress-active" style="width: 70%"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="exchange-gift-item">
                            <div class="gift-item">
                                <div class="gift-item-img">
                                    <img src="/themes/web/assets/images/gift.png">
                                </div>
                                <div class="gift-detail">
                                    <div class="gift-title">Gift exchange name Gift exchange name</div>
                                    <div class="gift-button">Exchange</div>
                                    <div class="gift-progress">
                                        <div class="progress-text">Remaining: <b>272/300</b></div>
                                        <div class="progress-bar">
                                            <div class="progress-active" style="width: 70%"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="gift-item">
                            <div class="gift-item-img">
                                <img src="/themes/web/assets/images/gift2.png">
                            </div>
                            <div class="gift-detail">
                                <div class="gift-title">Gift exchange name Gift exchange name</div>
                                <div class="gift-button">Exchange</div>
                                <div class="gift-progress">
                                    <div class="progress-text">Remaining: <b>272/300</b></div>
                                    <div class="progress-bar">
                                        <div class="progress-active" style="width: 70%"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
        </div>
        <div class="modal fade" id="popGift1" tabindex="-1" role="dialog" aria-labelledby="popGift1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered exchange-gift-popup" role="document">
                <div class="modal-content gift-modal-content">
                    <div class="close-popup" data-dismiss="modal" onclick="$('#popGift1').modal('hide');">+</div>
                    <h3 class="gift-modal-title">Gift exchange name</h3>
                    <div class="gift-modal-subtitle">Sent exchange request at 15:23 - 20, August 2021</div>
                    <div class="gift-modal-detail d-flex">
                        <img src="/themes/web/assets/images/gift1.png">
                        <div class="gift-modal-detail-text">
                            Egestas metus nascetur bibendum etiam cras urna, nunc. Elit interdum egestas euismod vel ac. In sit mi, dui massa, ultrices nunc. Justo, nisl, scelerisque dignissim et. Id est eget et, consectetur adipiscing sed. Metus id pharetra massa nisl, aenean facilisis.
                            Et auctor ultrices pellentesque in mi posuere habitasse. Neque, leo interdum at in. Ornare magna dui enim facilisis in nisl.
                        </div>
                    </div>
                    <div class="gift-modal-button" data-dismiss="modal" type="button" onclick="$('#popGift1').modal('hide');$('#popGift2').modal('show');">Exchange gift
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="popGift2" tabindex="-1" role="dialog" aria-labelledby="popGift2" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered exchange-gift-popup-small" role="document">
                <div class="modal-content gift-modal-content">
                    <div class="close-popup" data-dismiss="modal" onclick="$('#popGift2').modal('hide');">+</div>
                    <h3 class="gift-modal-title mb-20">Buy sticker successful</h3>
                    <div class="gift-modal-detail">
                        <p class="p-modal-gift">Bạn đã đổi <span>X.XXX</span> gems để lấy <span>X</span> sticker<br/> sticker_name
                        </p>
                    </div>
                    <div class="gift-modal-button" type="button" data-dismiss="modal" onclick="$('#popGift2').modal('hide');$('#popGift3').modal('show');">View sticker collection
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="popGift3" tabindex="-1" role="dialog" aria-labelledby="popGift3" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered exchange-gift-popup-small" role="document">
                <div class="modal-content gift-modal-content">
                    <div class="close-popup" data-dismiss="modal" onclick="$('#popGift3').modal('hide');$('#popGift4').modal('show');">+
                    </div>
                    <h3 class="gift-modal-title mb-20">Limited exchange</h3>
                    <div class="gift-modal-detail">
                        <p class="p-modal-gift">Limited exchange today, please come back tomorrow for more exchange times.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="popGift4" tabindex="-1" role="dialog" aria-labelledby="popGift4" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered exchange-gift-popup-small" role="document">
                <div class="modal-content gift-modal-content">
                    <div class="close-popup" data-dismiss="modal" onclick="$('#popGift4').modal('hide');">+</div>
                    <h3 class="gift-modal-title mb-20">Sent request successful</h3>
                    <div class="gift-modal-detail">
                        <p class="p-modal-gift">Your request to exchange stickers to gift_package_name has been successfully. We will deliver the gift to you as soon as possible!
                        </p>
                    </div>
                    <div class="gift-modal-button warning" type="button" data-dismiss="modal" onclick="$('#popGift4').modal('hide')">View sticker collection
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import {pushQueries, toPercent} from '../../utils/utils'
    import {mapGetters} from 'vuex'
    import {getAllExchangeGift, sendExchangeGift} from "../../models/exchange_gift";
    import {claimDailyBonus} from "../../models/reward";

    export default {
        name: "ExchangeGift",
        title: 'Exchange gift',

        data() {
            return {
                exchange_gifts: [],
                isLoading: true
            };
        },

        created() {
            //this.$store.commit('setMenuActive', 'inbox');

            this.fetch();
        },

        methods: {
            async fetch(page = 1) {
                const that = this;

                this.page = page;

                const params = {
                    page: this.page,
                };

                //pushQueries(this.$router, '/inbox', params);

                await axios.all([
                    getAllExchangeGift(params),
                ]).then(axios.spread((response) => {
                    that.isLoading = false;

                    //that.$store.commit("setLoading", false);

                    if (response.data.code != 0) {
                        return;
                    }

                    that.exchange_gifts = response.data.results.gifts || [];
                }));
            },
            sendExchangeGift(id){
                const that = this;
                const formData = new FormData();
                formData.append('id', id)
                sendExchangeGift(formData).then((response) => {
                    that.$store.commit("setLoading", false);
                    if (response.data.code != 0) {
                        return;
                    }
                    if(response.data.results.gifts){
                        that.exchange_gifts = response.data.results.gifts || [];
                    }
                    // window.location.href = '/exchange-gift';
                }).catch((response) => {
                    that.$store.commit("setLoading", false);
                    console.error(response)
                });
            },

            calcPercent(process, total) {
                return toPercent(process, total);
            },

        }
    }
</script>


<style scoped>
   /* .container{
        width: 940px;
        padding: 0;
    } */
</style>
